import { cn } from '../../lib/format.js';

const tones = {
  neutral: 'bg-mist/70 text-ink',
  muted: 'bg-transparent text-muted border border-mist',
  signal: 'bg-signal/10 text-signal',
  success: 'bg-success/10 text-success',
  danger: 'bg-danger/10 text-danger',
  warning: 'bg-bronze/12 text-bronze',
  solid: 'bg-ink text-white',
};

/** Status pills. Monospace so a column of them lines up. */
export const Badge = ({ tone = 'neutral', className, children, ...props }) => (
  <span
    className={cn(
      'inline-flex items-center gap-1 rounded px-1.5 py-0.5 font-mono text-2xs tracking-[0.06em] whitespace-nowrap uppercase',
      tones[tone] ?? tones.neutral,
      className,
    )}
    {...props}
  >
    {children}
  </span>
);

/** Shared status vocabulary, so an order reads the same in every grid. */
export const STATUS_TONE = {
  pending: 'warning', confirmed: 'signal', processing: 'signal',
  shipped: 'signal', delivered: 'success', cancelled: 'danger', refunded: 'danger',
  paid: 'success', failed: 'danger', created: 'muted', partially_refunded: 'warning',
  partially_paid: 'warning', cod: 'warning', overdue: 'danger',
  draft: 'muted', published: 'success', scheduled: 'signal', archived: 'muted',
  approved: 'success', rejected: 'danger', new: 'signal', read: 'muted',
  replied: 'success', closed: 'muted', active: 'success', expired: 'danger',
  disabled: 'muted', exhausted: 'warning', unfulfilled: 'muted', returned: 'danger',
};

export default Badge;
